import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { CompartmentItemFacade } from './compartment-item.facade';

@Injectable({
  providedIn: 'root',
})
export class CompartmentItemCreationGuard {
  constructor(private compartmentItemFacade: CompartmentItemFacade) {}

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    this.compartmentItemFacade.getSsccIdForNewCompartment();
    return of(true);
  }
}
